import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button, IconButton, EmptyState } from "@similarweb/ui-components";

import { DropdownContainer } from "pro-features/pages/segments/components/benchmarkOvertime/StyledComponents";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledButton = styled(Button)`
    white-space: nowrap;
`;

export const StyledEmptyState = styled(EmptyState)`
    padding: 24px;
    text-align: center;
    max-width: 1080px;
    width: 100%;
    border-radius: 6px;
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    background-color: ${colorsPalettes.carbon[0]};
    box-sizing: border-box;
    margin: auto;
`;

export const ButtonContainer = styled(CenteredFlexRow)`
    gap: 4px;
`;

export const SegmentsContainer = styled.div``;

export const SegmentsEllipsisButton = styled.div.attrs((_props) => ({
    children: (
        <IconButton
            type="flat"
            iconName="dots-more"
        />
    ),
}))`
    .SWReactIcons svg {
        width: 24px;
        height: 24px;
    }
`;

export const StyledDropdownContainer = styled(DropdownContainer)`
    width: auto;
`;
